module.exports = __webpack_public_path__ + "src/img/clock.92850579.svg";